import { shallowEqual, useSelector } from 'react-redux';
import type { LocationState } from 'redux-first-router';
import { ROUTE_COMPANY, ROUTE_COMPANY_WITH_EVENTS } from '@/constants/routes';
export function useCompanyCanonicalUrl() {
  const canonicalUrl = useSelector<{ location: LocationState }, string>(
    (state) => {
      if (
        [ROUTE_COMPANY, ROUTE_COMPANY_WITH_EVENTS].includes(state.location.type)
      ) {
        const { isoCode2, industry, exchange_ticker, companyname } =
          state.location.payload;
        return `/stocks/${isoCode2}/${industry}/${exchange_ticker}/${companyname}`;
      }
      console.warn(
        'useCompanyCanonicalUrl cannot be used outside company pages'
      );
      return '';
    },
    shallowEqual
  );
  return canonicalUrl;
}
